import { proxy } from 'valtio'
import { CommonApi, Option, TeacherOption } from '../../generated'
import { apiConfig } from '../apiConfig'
import { getTeacherName } from '../util/getName'

export const supervisorStore = proxy<{ items: TeacherOption[] }>({
  items: [],
})

const RESEARCH_STUDENT_ID = [8, 9, 10, 16, 17, 19]
const MASTER_ID = [11, 13]
const DOCTORAL_ID = [12, 14]
const EXCHANGE_ID = [18]

export const isAccept = (option: TeacherOption, programId?: number) => {
  let program: string
  if (programId && RESEARCH_STUDENT_ID.includes(programId)) {
    program = 'research'
  } else if (programId && MASTER_ID.includes(programId)) {
    program = 'master'
  } else if (programId && DOCTORAL_ID.includes(programId)) {
    program = 'doctoral'
  } else if (programId && EXCHANGE_ID.includes(programId)) {
    program = 'exchange'
  } else {
    program = 'other'
  }
  switch (program) {
    case 'research':
      return option.acceptResearchStudent
    case 'master':
      return option.acceptMaster || option.acceptDoctoral
    case 'doctoral':
      return option.acceptDoctoral
    case 'exchange':
      return option.acceptExchange
    default:
      return true
  }
}

new CommonApi(apiConfig).getTeachers().then((result) => {
  supervisorStore.items = result
})

const api = new CommonApi(apiConfig)

export async function loadSupervisor() {
  await api.getTeachers().then((result) => {
    supervisorStore.items = result
  })
}

export function getTeachersName(id?: number, defaultValue?: string) {
  if (!id) return
  return getTeacherName(supervisorStore.items, id, defaultValue)
}

export function getTeacherNameOptions(
  teachers: { items: TeacherOption[] },
  course?: Option,
  program?: Option
) {
  const filtered = teachers.items.filter((i) => i.courseId === course?.id)
  const result: Option[] = filtered.map((i) => ({
    label: i['name'],
    id: i.id,
    code: i.id.toString(),
    name: i.nameEn,
    nameJa: i.name,
    isOther: false,
    hidden: i.state === 'hidden',
  })).filter((i) => !i.hidden)
  result.sort((a, b) => {
    if (a.name < b.name) {
      return -1
    } else if (a.name === b.name) {
      return 0
    } else {
      return 1
    }
  })
  return result
}
